// src/components/support/forms/Finance.js
import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useAtom } from 'jotai';
import { appConstants, childList } from '../../../atomstore/store';
import { useRequestProcessor } from '../../../requestProcessor';
import { freeBeeLogin, getUnpaidInvoices } from '../../../queryfunctions/queryfunctions';
import { Browser } from "@capacitor/browser";
import { useNavigate } from 'react-router-dom';
import SpinnerLoading from '../../common/SpinnerLoading';
import CustomSelect from '../../common/CustomSelect';


const Finance = () => {
    const navigate = useNavigate();
    const { useQueryWrapper, useMutationWrapper } = useRequestProcessor();

    const [children] = useAtom(childList)
    const [selectedChild, setSelectedChild] = useState(0)
    const [constants] = useAtom(appConstants)
    // const [unpaidAmout, setUnpaidAmout] = useState(0)



    const { data: unpaidAmout, isLoading } = useQueryWrapper(
        ["programList", children[selectedChild]?.id],
        () => getUnpaidInvoices(children[selectedChild]),);


    const handleFreeBeeLogin = useMutationWrapper(
        "freeBeeLogin",
        (onSuccess) => {
            console.log("[Finance] Calling API: /chargebees/login ", {
                onSuccess: onSuccess,
                child_id: children[selectedChild]?.id,
            });
            return freeBeeLogin(onSuccess, children[selectedChild]);
        },
        {
            onSuccess: (data) => {
                console.log("[Finance] Chargebees Login response:", data);
            },
        }
    );

    const goToInvoice = () => {
        const invoiceUrl =
            constants.PaymentCheckUrl + "?child_id=" + children[selectedChild]?.id;
        window.open(invoiceUrl, "_blank", "location=no,closebuttoncaption=Back");
    };

    const openCapacitorSite = async (url) => {
        await Browser.open({ url: url });
    };
    const gotToFinance = () => {
        handleFreeBeeLogin.mutate((data) => {
            openCapacitorSite(data.response);
        });
    };


    return (
        <div className="fixed inset-0 bg-gray-50 z-50 overflow-y-auto">
            {isLoading && <SpinnerLoading />}
            <div className="sticky top-0 bg-white border-b p-4 flex items-center space-x-3">
                <button onClick={() => navigate(-1)}>
                    <ChevronLeft className="w-6 h-6 text-gray-600" />
                </button>
                <h2 className="text-lg font-bold text-gray-800 cursor-pointer" onClick={() => navigate(-1)}>Finance</h2>
            </div>

            <div className="p-4 space-y-3">
                {children.length > 1 && (
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Select Child</label>
                        <CustomSelect
                            value={selectedChild}
                            onChange={(val) => setSelectedChild(Number(val))}
                            options={children.map((child, idx) => ({
                                value: idx,
                                label: `${child?.name} ${child?.last_name}`,
                            }))}
                            placeholder="Select Child"
                        />
                    </div>
                )}

                <div className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100">
                    <div className="flex items-center justify-between mb-3">
                        <div>
                            <h3 className="font-semibold text-gray-800">Unpaid Invoices</h3>
                            <p className="text-sm text-gray-500">{children[selectedChild]?.name.split(' ')[0]}</p>
                        </div>
                        <span className="text-2xl font-bold text-red-500">₹{typeof unpaidAmout === "number" ? unpaidAmout : 0}</span>
                    </div>
                    <button onClick={goToInvoice} className="w-full bg-cyan-500 text-white py-3 rounded-xl font-semibold hover:bg-cyan-600 transition">
                        Pay Now
                    </button>
                </div>
                <button className="w-full bg-white rounded-2xl p-4 shadow-sm border border-gray-100 text-left active:scale-95 transition">
                    <div className="flex items-center justify-between" onClick={gotToFinance}>
                        <div>
                            <p className="font-semibold text-gray-800">Past Invoices</p>
                            <p className="text-sm text-gray-500">View payment history</p>
                        </div>
                        <ChevronRight className="w-5 h-5 text-gray-400" />
                    </div>
                </button>

                {[
                    { title: 'Fee Certificate', desc: 'Generate tax certificates', screen: "/fee" },
                    { title: 'Not Satisfied, Don\'t Pay', desc: 'Report service issues', screen: "/non-satisfaction" }
                ].map((item, idx) => (
                    <button key={idx} className="w-full bg-white rounded-2xl p-4 shadow-sm border border-gray-100 text-left active:scale-95 transition">
                        <div className="flex items-center justify-between" onClick={() => navigate(item?.screen)}>
                            <div>
                                <p className="font-semibold text-gray-800">{item.title}</p>
                                <p className="text-sm text-gray-500">{item.desc}</p>
                            </div>
                            <ChevronRight className="w-5 h-5 text-gray-400" />
                        </div>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default Finance;